import React from "react";
import { Link } from "react-router-dom";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Keep runtime failures visible in logs while preventing a blank page.
    // eslint-disable-next-line no-console
    console.error("App runtime error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container-aus py-20 text-center" data-testid="app-error-fallback">
          <div className="tiny-caps mb-2">Something went wrong</div>
          <h1 className="font-heading text-3xl font-bold">We hit an unexpected issue.</h1>
          <p className="text-aus-onyx/65 mt-3">
            Please refresh this page, or go back to a safe screen.
          </p>
          <div className="mt-5 flex items-center justify-center gap-2">
            <button type="button" className="btn-secondary text-sm" onClick={() => window.location.reload()}>
              Refresh page
            </button>
            <Link to="/" className="btn-primary text-sm">
              Go home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

